import { createClient } from "@supabase/supabase-js";

// Supabase credentials
// In production: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY as environment variables.
// The fallback values below are the project defaults and are safe to commit (anon key is public-facing).
const supabaseUrl =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined) ??
  "https://gejxrsievubpqspklpap.supabase.co";

const supabaseAnonKey =
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ??
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdlanhyc2lldnVicHFzcGtscGFwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzczOTgyNDQsImV4cCI6MjA5Mjk3NDI0NH0.wvzwxsXfyekf08ETBqPGjQWg2NKbRcsTa9d5HD6qTfY";

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. " +
    "Set these environment variables before building for production."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export const isSupabaseConnected = true;

export type Database = {
  public: {
    Tables: {
      articles: { Row: Record<string, unknown> };
      categories: { Row: Record<string, unknown> };
      authors: { Row: Record<string, unknown> };
      media: { Row: Record<string, unknown> };
      newsletter_subscribers: { Row: Record<string, unknown> };
    };
  };
};
